import { useState } from "react";
import InputField from "components/fields/InputField";
import Checkbox from "components/checkbox";
import { post } from "utils/apiClient";
import apiRouteConstants from "constants/apiRouteConstants";
import { useNavigate } from "react-router-dom";

export default function SignIn() {
  const [userDetails, setUserDetails] = useState({
    emailOrNumber: "",
    password: "",
    otp: "",
  });
  const [requires2FA, setRequires2FA] = useState(false);
  const [pendingToken, setPendingToken] = useState(null);
  const navigate = useNavigate();

  const completeLogin = (res) => {
    if (res.data.token) {
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      navigate("/admin");
    }
  };

  const handleSignIn = async () => {
    try {
      if (requires2FA) {
        const res = await post(apiRouteConstants.verify2fa, {
          pendingToken,
          otp: userDetails.otp,
        });
        completeLogin(res);
        return;
      }

      const res = await post(apiRouteConstants.auth, userDetails);

      if (res.data.requires2FA) {
        setRequires2FA(true);
        setPendingToken(res.data.pendingToken);
        return;
      }

      completeLogin(res);
    } catch (err) {
      console.log(err);
    }
  };

  const handleBackToSignIn = () => {
    setRequires2FA(false);
    setPendingToken(null);
    setUserDetails((prev) => ({ ...prev, otp: "" }));
  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          {requires2FA ? "Two-Factor Auth" : "Sign In"}
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          {requires2FA
            ? "Enter the 6-digit code from Google Authenticator"
            : "Enter your email and password to sign in!"}
        </p>

        {!requires2FA && (
          <>
            <InputField
              variant="auth"
              extra="mb-3"
              label="Email or Phone*"
              placeholder="mail@simmmple.com"
              id="emailOrNumber"
              type="text"
              onChange={(e) =>
                setUserDetails({
                  ...userDetails,
                  emailOrNumber: e.target.value,
                })
              }
            />

            <InputField
              variant="auth"
              extra="mb-3"
              label="Password*"
              placeholder="Min. 8 characters"
              id="password"
              type="password"
              value={userDetails.password}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSignIn();
                }
              }}
              onChange={(e) =>
                setUserDetails({ ...userDetails, password: e.target.value })
              }
            />

            <div className="mb-4 flex items-center justify-between px-2">
              <div className="flex items-center">
                <Checkbox />
                <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
                  Keep me logged In
                </p>
              </div>
            </div>
          </>
        )}

        {requires2FA && (
          <InputField
            variant="auth"
            extra="mb-3"
            label="Authenticator code*"
            placeholder="123456"
            id="otp"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={userDetails.otp}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSignIn();
              }
            }}
            onChange={(e) =>
              setUserDetails({ ...userDetails, otp: e.target.value })
            }
          />
        )}

        <button
          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          onClick={() => handleSignIn()}
        >
          {requires2FA ? "Verify Code" : "Sign In"}
        </button>

        {requires2FA && (
          <button
            type="button"
            className="mt-3 w-full text-sm font-medium text-brand-500"
            onClick={handleBackToSignIn}
          >
            Back to sign in
          </button>
        )}
      </div>
    </div>
  );
}
